import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { SaveAndExtractComponent } from './save-and-extract.component';
import { SharedUiModule } from '@emi/shared/ui';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    SharedUiModule,
  ],
  declarations: [
    SaveAndExtractComponent
  ],
  exports: [
    SaveAndExtractComponent
  ],
})
export class SharedFeatureSaveAndExtractModule {}
